import { v4 as uuid } from 'uuid';

export const tools = {
	frontEnd: {
		name: 'Front End Technologies',
		tools: [
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621057027/portfolio/888909_gsm1dg.png',
				title: 'HTML',
				subtitle: 'HTML is the standard markup language for creating Web pages',
				link: 'https://en.wikipedia.org/wiki/HTML',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621057114/portfolio/888847_zgqzgm.png',
				title: 'CSS',
				subtitle: ' CSS describes how HTML elements are to be displayed',
				link: 'https://en.wikipedia.org/wiki/CSS',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621057140/portfolio/sass-1_who6nr.svg',
				title: 'Sass',
				subtitle: 'Officially described as “CSS with superpowers"',
				link: 'https://sass-lang.com/',
			},

			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622682950/portfolio/react-2_sp34jt.svg',
				title: 'React',
				subtitle: 'A JavaScript library for building user interfaces',
				link: 'https://reactjs.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1627290375/portfolio/nextjs_icon_132160_sucwpd.svg',
				title: 'NextJS',
				subtitle: 'The React Framework for Production',
				link: 'https://nextjs.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1627290032/portfolio/redux_original_logo_icon_146365_hno9ux.webp',
				title: 'Redux',
				subtitle: 'A Predictable State Container for JS Apps',
				link: 'https://redux.js.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622686765/portfolio/gsap-greensock_kd72pe.svg',
				title: 'GSAP',
				subtitle: 'Professional-grade JavaScript animation for the modern web',
				link: 'https://greensock.com/gsap/',
			},
		],
	},
	backEnd: {
		name: 'Back End Technologies',
		tools: [
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622683587/portfolio/nodejs-icon_lteom2.svg',
				title: 'Node.js',
				subtitle:
          'A JavaScript runtime built on Chrome\'s V8 JavaScript engine.',
				link: 'https://nodejs.org/en/about/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622683711/portfolio/mongodb-icon-1_or49gs.svg',
				title: 'MongoDB',
				subtitle: 'The database for modern applications',
				link: 'https://www.mongodb.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622683931/portfolio/postgresql_ymyi5u.svg',
				title: 'PostgreSQL',
				subtitle: 'The world\'s most advanced open source relational database',
				link: 'https://www.postgresql.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622684869/portfolio/graphql_fqubor.svg',
				title: 'GraphQL',
				subtitle: 'A query language for APIs',
				link: 'https://graphql.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621057581/portfolio/express-js-logo_mngqbz.png',
				title: 'Express',
				subtitle: 'Fast, unopinionated, minimalist web framework for Node.js',
				link: 'https://expressjs.com/',
			},
		],
	},
	design: {
		name: 'Design',
		tools: [
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622670033/portfolio/figma-1_s3suke.svg',
				title: 'Figma',
				subtitle: 'The collaborative design tool',
				link: 'https://www.figma.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622670337/portfolio/adobe-illustrator-cc_exu8az.svg',
				title: 'Adobe Illustrator',
				subtitle: 'The professional vector-based design and drawing program',
				link: 'https://www.adobe.com/products/illustrator.html',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622694770/portfolio/google-fonts-2021-2_vy3zlw.svg',
				title: 'Google Fonts',
				subtitle: 'API for using fonts via CSS',
				link: 'https://fonts.google.com/',
			},
		],
	},
	analytics: {
		name: 'RESEARCH & ANALYTICS',
		tools: [
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621982071/portfolio/google-analytics-4_jirwwi.svg',
				title: 'Google Analytics',
				subtitle: 'Web analytics service',
				link: 'https://analytics.google.com/',
			},
		],
	},
	developerTools: {
		name: 'Developer tools',
		tools: [
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1627290303/portfolio/file_type_typescript_icon_130108_wp19bu.svg',
				title: 'TypeScript',
				subtitle: 'Static type definitions for JavaScript',
				link: 'https://www.typescriptlang.org/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622681140/portfolio/netlify_qxdnsv.svg',
				title: 'Netlify',
				subtitle: 'Powerful serverless hosting',
				link: 'https://www.netlify.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1621977768/portfolio/postman-logo-F43375A2EB-seeklogo.com_eoveyu.png',
				title: 'Postman',
				subtitle: 'Best tool for building, testing and modifying APIs',
				link: 'https://www.postman.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622685735/portfolio/ubuntu-4_v5dbhu.svg',
				title: 'Ubuntu Server',
				subtitle: 'Server operating system',
				link: 'https://ubuntu.com/server',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622689759/portfolio/npm_yzd9fe.svg',
				title: 'npm',
				subtitle: ' Node package manager',
				link: 'https://www.npmjs.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622678644/portfolio/firebase-1_tvacw5.svg',
				title: 'Firebase',
				subtitle: 'Platform for creating mobile and web applications',
				link: 'https://firebase.google.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622679203/portfolio/github-icon-1_tooeon.svg',
				title: 'Github',
				subtitle: 'Code hosting platform for version control and collaboration',
				link: 'https://github.com/',
			},
			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622679583/portfolio/digitalocean-tile_khom9j.svg',
				title: 'Digital Ocean',
				subtitle: 'Cloud computing platform',
				link: 'https://www.digitalocean.com/',
			},

			{
				id: uuid(),
				image:
          'https://res.cloudinary.com/c1oud9/image/upload/v1622681306/portfolio/aws-2_gf2hd7.svg',
				title: 'Amazon Web Services',
				subtitle: 'The market leader platform for cloud ecosystems',
				link: 'https://aws.amazon.com/',
			},
		],
	},
};
